export default __webpack_public_path__ + "static/media/Profile_iocn_orange.e3d8864a.svg";